import { CivilDate } from 'tc39-proposal-temporal';
import { toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';

export function getToday(i18n, timeZone) {
  const today = i18n.getToday({ timeZone: toIANATimeZone(timeZone) });
  const civilDate = new CivilDate(today.year, today.month, today.day);

  return civilDate;
}
